// extracted by mini-css-extract-plugin
export var pageContainer = "Layout-module--page-container--1WnJE";
export var mainArea = "Layout-module--main-area--2XOzU";
export var content = "Layout-module--content--2cIi8";
export var sidebar = "Layout-module--sidebar--2Zbb_";
export var notifications = "Layout-module--notifications--345dO";